export default __webpack_public_path__ + "static/faq-97cff1fb9f2c4f6342d6f117daf025cb.jpeg";